import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import href from '#utilities/js/ea/href.js'
import globals from '../../ea/globals.js'
import rte from '../rte.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import closest from "@mailobj-browser/front/js/selectors/closest.js"

const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault
  ]),
  task: (
    button
  ) => {
    const form = closest('form', button)
    const rte = one('iframe[data-rte]', form)

    if (rte && rte.id) {
      const url = href('auth/colorpanel', {
        'id_txt': 'rte',
        'id_bkg': 'rte',
        'table': '12x19',
        'preview': '1',
        'cancel': '1',
        'color': encodeURIComponent(globals.ea_rte_forecolor)
      })

      globals.ea_rte_update_editor(globals.ea_rte_current)
      globals.ea_rte_context_menu(button, null, rte.id, 'forecolor', 'rte_opt_cp', url)
    }
  }
})

// ea_rte_update_editor(ea_rte_current);
// ea_rte_context_menu(this,null,'id_msg_text','forecolor',
//   'rte_opt_cp',
//   '/mailo/auth/colorpanel.php?id_txt=rte&id_bkg=rte&table=12x19&preview=1&cancel=1' +
//   '&color='+encodeURIComponent(ea_rte_forecolor))

export const highlight = (
  button,
  modifier,
  text
) => {
  if (closest('font[color]', text)) {
    button.classList.add(modifier)
  }
}

export default button => {
  onClick.listen(button)
  rte(button, object(null, { highlight }))
}
